/* tslint:disable */
type DuplicateFilingSubmissionStatus =
  'EXCLUDED' |
  'DUPLICATE';
module DuplicateFilingSubmissionStatus {
  export const EXCLUDED: DuplicateFilingSubmissionStatus = 'EXCLUDED';
  export const DUPLICATE: DuplicateFilingSubmissionStatus = 'DUPLICATE';
  export function values(): DuplicateFilingSubmissionStatus[] {
    return [
      EXCLUDED,
      DUPLICATE
    ];
  }
}

export { DuplicateFilingSubmissionStatus }